var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-header-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAssessmentBarRemoved,
      expression: "!isAssessmentBarRemoved"
    }],
    staticClass: "row-container"
  }, [_c('v-row', {
    staticClass: "pt-1"
  }, [_c('v-col', {
    staticClass: "p-0 d-flex flex-row justify-content-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "readiness-row d-flex flex-column justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "w-100 top-text"
  }, [_vm._v("Assess your organization's CMMC posture")])])]), _c('v-col', {
    staticClass: "p-0 pt-2 d-flex flex-row justify-content-center align-items-center",
    class: _vm.assessmentRowStyle,
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "color": '#fff'
    },
    on: {
      "click": _vm.goToTaskAssessment
    }
  }, [_vm._v(" Start Now ")])], 1)], 1)], 1), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBackgroundImage,
      expression: "showBackgroundImage"
    }],
    staticClass: "page-header-bg-image",
    style: {
      backgroundImage: `url("${_vm.itemBgImg}")`
    }
  }, [_vm.itemBgImgHasOverlay ? _c('div', {
    staticClass: "page-header-overlay",
    style: {
      'backgroundColor': `rgba(0, 0, 0, ${_vm.itemBgImgOpacity})`
    }
  }) : _vm._e(), _c('div', {
    staticClass: "container p-0"
  }, [_c('v-row', {
    class: _vm.pageHeaderStyle,
    attrs: {
      "id": "page-header-row-container"
    }
  }, [_vm._t("default")], 2)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }